import { InputModal, RadioGroup, Radio } from "@certn/cascadia-react";
import { slugify, slugifyPath } from "@certn/utils";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { SummaryItem } from "../components/SummaryItem";
import {
  CascadiaOneOfProps,
  withCascadiaOneOfProps,
} from "../wrappers/withCascadiaOneOfProps";

export function RadioGroupControl(props: CascadiaOneOfProps) {
  const { isSummaryForPath, formID } = useContext(CascadiaJsonFormContext);

  if (
    isSummaryForPath?.(props.path) &&
    !props.uischema.options?.ignoreGlobalIsSummary
    // unusual option that is used to render the control as editable
    // despite the rest of the form being read-only
  ) {
    const selectedOption = props.items.find(
      (item) => item.value === props.data
    );

    return (
      <SummaryItem label={props.label}>
        {selectedOption?.label || props.data}
      </SummaryItem>
    );
  }

  const testIDPath = `${slugifyPath(props.path)}`;
  const { options } = props;
  const labelInfo =
    options?.info ??
    (options?.more_info ? <InputModal {...options.more_info} /> : undefined);

  return (
    <RadioGroup
      description={props.description}
      errors={props.errors}
      info={labelInfo}
      isCard={props.options.card}
      stretchChildren={props.options.stretchChildren}
      orientation={props.options.orientation}
      isDisabled={!props.enabled}
      isInvalid={props.invalid}
      isRequired={props.required}
      label={props.label}
      name={props.path}
      onBlur={props.setTouched}
      onChange={props.setValue}
      value={props.data}
      children={props.items.map((option, index) => (
        <Radio
          key={index}
          value={option.value}
          description={option.description}
          // TODO: BE is not returning testIDs yet - option.title is undefined
          // testID={`check-engine-${slugify(option.title)}-radio`}
          testID={
            formID
              ? `${formID}-${testIDPath}-radio-field-${slugify(option.value)}`
              : `${testIDPath}-radio-field-${slugify(option.value)}`
          }
        >
          {option.label}
        </Radio>
      ))}
      testID={
        formID
          ? `${formID}-${testIDPath}-radio-group`
          : `${testIDPath}-radio-group`
      }
    />
  );
}

export const RadioGroupRenderer = withCascadiaOneOfProps(RadioGroupControl);
